import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http'
import { Observable } from 'rxjs/Observable';

import 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/throw';

@Injectable()
export class DataServiceProvider {

  apiRoot: string = 'assets/data/menus.json';

  public Menus: any;

  constructor(private http : HttpClient) {
    console.log('Hello DataServiceProvider Provider');
  }

  getMenu(){

    return this.http
               .get(this.apiRoot)
               .do(data => {
                  JSON.stringify(data);
                  this.Menus = data;
               })
               .catch(this.handleError);

  }

  private handleError(error: HttpErrorResponse){

    let errorMessage = {};

    if (error.error instanceof Error) {
        // A client-side or network error occurred. Handle it accordingly.
        errorMessage = `An error occurred: ${error.error.message}`;
        console.log(error.error);

    } else {

        // The backend returned an unsuccessful response code.
        // The response body may contain clues as to what went wrong,
        errorMessage = { status: error.status, message: error.error.Message };
        console.log(error.error);

        if(error.status == 401){

        }

    }

    return Observable.throw(errorMessage);

  }

}



// WEBPACK FOOTER //
// ./src/providers/data-service/data-service.ts